import { useQuery } from "@tanstack/react-query"
import { bigblueIntegrationQuery } from "modules/settings/lib/bigblue/bigblueIntegrationQuery"

export function useBigBlueIntegrationQuery(...args: Parameters<typeof bigblueIntegrationQuery>) {
  return useQuery(bigblueIntegrationQuery(...args))
}
